const initialState = {
  loading: false,
  data: {},
  error: null,
};

/**
 * Reducer for constants. This reducer is responsible for storing any global constants that are fetched from the server and used throughout the application. The constants are typically configuration values that may change based on the environment or server settings, such as API endpoints, feature flags, or other dynamic values that need to be accessible in the frontend code.
 * The reducer listens for actions related to fetching constants, and updates the state accordingly. The initial state is an object with a loading flag, a data object to hold the constants, and an error field for any errors that may occur during fetching.
 * In this implementation, the reducer simply returns the data from the state, or the initial state if no data is present. This allows components to access the constants directly from the Redux store without needing to handle loading or error states in this particular reducer.
 * @param {{loading: boolean, data: Object, error: string|null}} state
 * @returns {Record<string, any>} The constants data from the state, or the initial state if no data is present.
 */
export default function constants(state = initialState) {
  return state;
}
